module.exports = __WEBPACK_EXTERNAL_MODULE__sentry_browser__;